/* eslint-disable jsx-a11y/control-has-associated-label */
import cn from 'classnames'
import { CSSProperties, FC } from 'react'

import { BG_COLOR_VARIANT, FG_COLOR_VARIANT } from '../../../constants'
import { ColorOption } from '../utils'
import styles from './Pallete.module.scss'

interface PalleteProps {
  onResetColor: () => void
  onSetColor: (color: string) => void
  label: string
  options: ColorOption<BG_COLOR_VARIANT | FG_COLOR_VARIANT>[]
  className?: string
}

const Pallete: FC<React.PropsWithChildren<PalleteProps>> = ({
  onResetColor,
  onSetColor,
  label,
  options,
  className,
}) => (
  <div className={cn(styles.pallete, className)}>
    <span className={styles.label}>{label}</span>
    <button type="button" className={styles.resetButton} onClick={onResetColor} />
    {options.map(({ value }) => (
      <button
        onClick={() => onSetColor(value)}
        style={{ background: value } as CSSProperties}
        className={styles.setButton}
        type="button"
        key={value}
      />
    ))}
  </div>
)

export default Pallete
